export default __webpack_public_path__ + "static/sunchasers-banner-cfcbddf39c78548f6d7f8659cca4256a.webp";